"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const api_1 = require("../api");
function implementation(implementation, ns, name, ...parameters) {
    return { id: api_1.operationId(ns, name, ...parameters), func: implementation };
}
exports.implementation = implementation;
function runtimeValue(value, type) {
    return { type, value };
}
exports.runtimeValue = runtimeValue;
//# sourceMappingURL=implementation.js.map